<template>
  <div class="tw-flex tw-w-full tw-h-full tw-flex-col">
    <div class="tw-p-[30px] tw-w-fit tw-max-h-[95px] tw-h-[95px]">
      <div
        id="chr-sheading-score"
        class="tw-text-[18px] tw-text-[#211F58] tw-font-semibold tw-mt-[4px]"
      >
        {{
          getComponentUiText(
            "app-component-assessments-question-type-2-icon-tooltip-score-1",
          )
        }}
      </div>
    </div>

    <div v-if="loading" class="custom-global-skeleton tw-w-full tw-h-full" />
    <div
      v-else
      class="tw-flex tw-flex-1 tw-overflow-hidden tw-justify-center tw-w-full tw-h-full"
    >
      <div class="tw-mt-[9px]">
        <CyberScoreChart
          :current-score="currentScore"
          :pcnt-score="pcntScore"
          :color="color"
          :color-default="colorDefault"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import CyberScoreChart from "./cyberScoreChart.vue";
import { getComponentUiText } from "@/utils/utilities";
const props = defineProps({
  color: {
    type: String,
    default: "#F7553C",
  },
  colorDefault: {
    type: String,
    default: "#FEE5E2",
  },
  currentScore: {
    type: Number,
    default: 0,
  },
  pcntScore: {
    type: Number,
    default: 0,
  },
  loading: {
    type: Boolean,
    default: true,
  },
});
</script>
